export default __webpack_public_path__ + "static/media/IconReject.c260a40c.svg";